<template>
  <div :style="{'min-height': tvformats.length === 0 ? '140px' : 'initial'}">
    {{ $t('contentUploadHint') }}
    {{ $t('contentUploadVideoFormatsHint') }}
    <table class="resolution-table my-2">
      <th>{{ $t('contentUploadHintVideoFormatsHeader_1') }}</th>
      <th class="nowrap">
        {{ $t('contentUploadHintVideoFormatsHeader_2') }}
      </th>
      <tr
        v-for="tvformat in tvformats"
        :key="tvformat.id"
      >
        <td>{{ nameLookup[tvformat.name] || tvformat.name }}</td>
        <td class="nowrap">
          {{ tvformat.width }} x {{ tvformat.height }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    tvformats: {
      type: Array[Object],
      required: true,
    },
  },
  data() {
    return {
      nameLookup: {
        '16:9': this.$t('landscape'),
        '9:16': this.$t('portrait'),
      },
    };
  },
};
</script>

<style scoped>
.resolution-table >>> tr,
.resolution-table >>> td,
.resolution-table >>> th {
  padding-top: 2px;
  padding-bottom: 2px;
  padding-right: 16px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/ContentUploadAvailableFormats.vue